import { getErrorMessage } from "../../../utils/apiError";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";

// Loading / not-linked / error states for a performance query.
// Renders `children(data)` once loaded.
const QueryState = ({ query, loadingText = "Loading…", children }) => {
  if (query.error?.response?.status === 403) {
    return (
      <div className={cx(ui.alert, ui.alertGray)}>
        {getErrorMessage(
          query.error,
          "You don't have access to this evaluation.",
        )}
      </div>
    );
  }
  if (query.isLoading) {
    return (
      <div className={cx(ui.card, ui.empty)}>
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        {loadingText}
      </div>
    );
  }
  if (query.isError) {
    return (
      <div className={cx(ui.alert, ui.alertDanger)}>
        {getErrorMessage(query.error, "Unable to load this page.")}
      </div>
    );
  }
  return children(query.data);
};

export default QueryState;
